<nav class="navbar navbar-expand navbar-giphar">
  <div class="navbar-collapse collapse justify-content-start">
    <img class="mt-2 ml-2" [src]="logo_png" alt="logo giphar" width="190" height="52"/>
  </div>
    <div class="navbar-collapse collapse justify-content-end">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" (click)="setModalState(true)">Mon Compte</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="logout()">Déconnexion</a>
        </li>
      </ul>
    </div>
</nav>

<app-pharmacie-edit-modal
  *ngIf="afficherMonCompteModal"
  (modalStateChanged)="setModalState($event)"
></app-pharmacie-edit-modal>
